import { render, staticRenderFns } from "./userPolicy.vue?vue&type=template&id=0afed13d&scoped=true"
import script from "./userPolicy.vue?vue&type=script&lang=js"
export * from "./userPolicy.vue?vue&type=script&lang=js"
import style0 from "./userPolicy.vue?vue&type=style&index=0&id=0afed13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afed13d",
  null
  
)

export default component.exports